export default __webpack_public_path__ + "static/media/filter.a1f705fb.svg";